import { Text, Icon, Stack, IconButton, TooltipHost, ActionButton } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import SystemClient from '../../../../../system/SystemClient';
import { PlanillaPartidoContext } from '../../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { Jugador } from '../../../../../system/Jugador/Jugador';
import { genkey } from '../../../../../common/constants';
import { useContainerStyle } from '../../../../../common/custom-hooks/useStyles';

export const JugadorCardForConfeccion = ({
  jugador,
  system,
  context,
  deleteJugador,
  disabledApparience,
  suspendedApparience,
  inactiveApparience,
  showCapitanButton,
  setCapitan,
  isCapitan,
}: {
  jugador: Jugador;
  system: SystemClient;
  context: PlanillaPartidoContext;
  deleteJugador: (j: Jugador) => void;
  disabledApparience: boolean;
  suspendedApparience: boolean;
  inactiveApparience: boolean;
  showCapitanButton?: boolean;
  isCapitan?: boolean;
  setCapitan?: () => void;
}) => {
  const imgStackStyles = {
    root: {
      marginRight: '15px',
    },
  };

  const getPosicionText = (val: number) => {
    const posicion = context.posicionesJugador?.find((o) => Number(o.getId()) === Number(val));
    if (posicion) {
      return posicion.getDescripcion();
    }
    return '';
  };

  const containerStyle = useContainerStyle();

  return (
    <div className="ms-Grid-col ms-sm10 mt-2">
      <div
        className="ms-Grid"
        style={{
          ...containerStyle,
          backgroundColor:
            inactiveApparience || suspendedApparience ? '#FFDBDB' : disabledApparience ? '#FFFFF0' : '',
        }}
      >
        <div className={'ms-Grid-row mt-1'} style={{ padding: '3px', margin: '0.2rem' }}>
          <Stack horizontal>
            <Stack.Item styles={imgStackStyles}>
              {jugador.getFoto() ? (
                <Image
                  src={system.getJugadorSystem().getUrlForImage(jugador.getFoto())}
                  imageFit={ImageFit.cover}
                  maximizeFrame
                  styles={{
                    root: {
                      margin: '0 auto',
                      borderRadius: '50%',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                  className="player-card-img"
                />
              ) : (
                <Image
                  src={'/images/persona_default.jpg'}
                  imageFit={ImageFit.cover}
                  maximizeFrame
                  className="player-card-img"
                  styles={{
                    root: {
                      margin: '0 auto',
                      borderRadius: '50%',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                  }}
                />
              )}
            </Stack.Item>

            <Stack.Item grow>
              <Text variant="mediumPlus" className="bold" block>
                {jugador.getApellido()}, {jugador.getNombre()}
              </Text>
              {jugador.getDocumentoNumero() && (
                <>
                  <Text variant="small" className="secondary-text">
                    DNI:
                  </Text>{' '}
                  <Text variant="small" className="secondary-text">
                    {jugador.getDocumentoNumero()}
                  </Text>
                </>
              )}

              {jugador.getClase() && (
                <Text variant="small" aria-label="Año de nacimiento" className="secondary-text" block>
                  ({jugador.getClase()}){' '}
                  {(suspendedApparience || inactiveApparience) && (
                    <Text
                      variant="small"
                      style={{ fontWeight: 500, color: 'red', display: 'inline-block' }}
                      aria-label="Año de nacimiento"
                      className="secondary-text"
                      block
                    >
                      - {suspendedApparience ? 'Suspendido' : inactiveApparience ? 'Inactivo' : ''}
                    </Text>
                  )}
                </Text>
              )}

              {jugador.getJpid() && (
                <Text variant="small" aria-label="Posición" className="secondary-text" block>
                  {getPosicionText(jugador.getJpid())}
                </Text>
              )}
            </Stack.Item>
            <Stack.Item>
              <Icon
                iconName="Cancel"
                className="remove-item-cross clickable"
                onClick={() => {
                  deleteJugador(jugador);
                }}
              ></Icon>
              {showCapitanButton && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 15,
                    right: 15,
                  }}
                >
                  <TooltipHost
                    content={isCapitan ? 'Es capitán' : 'Designar como capitán'}
                    id={genkey()}
                    calloutProps={{ gapSpace: 0 }}
                    // styles={{ root: { display: 'inline-block' } }}
                  >
                    {isCapitan ? (
                      <ActionButton
                        // iconProps={addFriendIcon}
                        allowDisabledFocus
                        checked={isCapitan}
                        onClick={setCapitan}
                      >
                        <span className="" style={{ fontWeight: 600, fontSize: 20 }}>
                          C
                        </span>
                      </ActionButton>
                    ) : (
                      <IconButton
                        iconProps={{ iconName: 'PartyLeader' }}
                        checked={isCapitan}
                        onClick={setCapitan}
                      ></IconButton>
                    )}
                  </TooltipHost>
                </div>
              )}
            </Stack.Item>
          </Stack>
        </div>
      </div>
    </div>
  );
};
